import { Typography } from '@material-ui/core';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { constants } from 'helpers/constants';
import React, { useMemo } from 'react';

import NoticeProductPending from './NoticeProductPending';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
}

export const SalePageLink = ({ currentProduct, currentUserId, physicalProductPending }: IProps) => {
  const clipBoardText = useMemo(() => {
    const { default_sales_page, producer_id, id } = currentProduct;
    const { SalesPage } = constants.links;
    const userIsOwerProduct = producer_id === currentUserId;

    const urlSalesPage = new URL(`${id}`, SalesPage);
    const urlSalesPageAffiliated = new URL(`${id}?a=${currentUserId}`, SalesPage);

    if (!default_sales_page && userIsOwerProduct) return urlSalesPage;

    return urlSalesPageAffiliated;
  }, [currentProduct, currentUserId]);

  return (
    <Typography variant='body2' color='textSecondary' component='div'>
      {physicalProductPending ? (
        <NoticeProductPending />
      ) : (
        <CustomCopyToClipboard fullWidth disableUnderline text={clipBoardText.href} style={{ paddingTop: 1 }} />
      )}
    </Typography>
  );
};
